export default "__VITE_ASSET__9ae2ba91__"